import React, { useState } from 'react'
import { GpParam } from "../../../types/GpParam"

type Props = {
    gpParamsForm: GpParam | undefined
    gpParams: GpParam | undefined
    setGpParamsForm: (gpParamsForm: GpParam | undefined) => void
    fetchGpParams: () => void
}
export default function ModalTokenKifal(props: Props) {

    const [ isKifalServiceTokenHidden, setIsKifalServiceTokenHidden ] = useState<boolean>(true)
    const [ isKifalCotationTokenHidden, setIsKifalCotationTokenHidden ] = useState<boolean>(true)

    const submitKifalToken = (e: any) => {
        e.preventDefault()
        fetch(localStorage.backoffice_api + '/api/gpParametres', {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                authorization: localStorage.JWT,
            },
            body: JSON.stringify(props.gpParamsForm),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response.json()
            })
            .then(() => {
                document.getElementById("closeButtonKifalTokenModal")?.click()
                props.fetchGpParams()
            })
            .catch((error) => {
                console.log(error)
            })
    }

    return (
        <div data-backdrop="static" className="modal fade" id="modalKifalToken" role="dialog" aria-labelledby="modalKifalTokenLabel" aria-hidden="true">
            <form id="kifalTokens" onSubmit={submitKifalToken} className={"tw-h-full"}>
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="createModalLabel">Tokens Kifal</h5>
                            <button onClick={() => props.setGpParamsForm(props.gpParams)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="card-body p-2">
                                <div className="py-2">
                                    <span>Token API Référentiel Kifal</span>
                                    <div className={"tw-flex tw-flex-row tw-items-center"}>
                                        <input
                                            className="form-control form-control-sm"
                                            type={isKifalServiceTokenHidden ? "password" : "text"}
                                            name="GRP_KifalServiceToken"
                                            id="GRP_KifalServiceToken"
                                            onChange={(e) => props.setGpParamsForm({
                                                ...props.gpParamsForm!,
                                                GRP_KifalServiceToken: (e.target.value as string) ?? "",
                                            })}
                                            value={props.gpParamsForm?.GRP_KifalServiceToken ?? ""}
                                        />
                                        <i onClick={() => setIsKifalServiceTokenHidden(!isKifalServiceTokenHidden)} role="button"
                                           className={"fa-solid p-2 " + (isKifalServiceTokenHidden ? " fa-eye" : " fa-eye-slash")}
                                           style={{
                                               color: "darkgray",
                                               cursor: "pointer",
                                           }}>
                                        </i>
                                    </div>
                                </div>
                                <div className="  py-2">
                                    <span>Token API Cotation Kifal</span>
                                    <div className={"tw-flex tw-flex-row tw-items-center"}>
                                        <input
                                            className="form-control form-control-sm"
                                            type={isKifalCotationTokenHidden ? "password" : "text"}
                                            name="GRP_KifalCotationToken"
                                            id="GRP_KifalCotationToken"
                                            onChange={(e) => props.setGpParamsForm({
                                                ...props.gpParamsForm!,
                                                GRP_KifalCotationToken: (e.target.value as string) ?? "",
                                            })}
                                            value={props.gpParamsForm?.GRP_KifalCotationToken ?? ""}
                                        />
                                        <i onClick={() => setIsKifalCotationTokenHidden(!isKifalCotationTokenHidden)} role="button"
                                           className={"fa-solid p-2 " + (isKifalCotationTokenHidden ? " fa-eye" : " fa-eye-slash")}
                                           style={{
                                               color: "darkgray",
                                               cursor: "pointer",
                                           }}>
                                        </i>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => props.setGpParamsForm(props.gpParams)} id="closeButtonKifalTokenModal" type="button" className="btn btn-secondary" data-dismiss="modal">Annuler
                            </button>
                            <input value={"Sauvegarder"} type="submit" className="btn btn-primary"/>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    )
}